document.addEventListener('DOMContentLoaded', () => {

    // ===== Sanakirja kieliversioille =====
    const messagesByLang = {
        'fi': {
            name: 'Täytä etunimi kenttä',
            company: 'Täytä yritys kenttä',
            headcount: 'Täytä henkilöstömäärä kenttä',
            email: 'Täytä sähköpostiosoite kenttä',
            emailWrong: 'Sähköpostiosoite on virheellisessä muodossa',
            phone: 'Täytä puhelin kenttä',
            phoneShort: 'Puhelinnumeron tulee olla vähintään 9 merkkiä pitkä',
            message: 'Kerro meille lyhyesti mitä yhteydenottosi koskee',
            infoMessage: 'Viestiä lähetetään...',
            errorMessage: 'Viestin lähettämisessä tapahtui virhe. Päivitä sivu ja koita uudelleen.',
            successTitle: 'Kiitos viestistäsi',
            successText: 'Olemme sinuun yhteydessä mahdollisimman pian',
            botMessageTitle: 'Viestin lähettämisessä tapahtui virhe',
            botMessageText: 'Lomakkeen lähettämisessä tapahtui virhe. Päivitä sivu ja yritä uudelleen. Mikäli ongelma toistuu, ota yhteyttä: <b>marketing[at]finago.com</b>'
        },
        'en-US': {
            name: 'Please fill firstname field',
            company: 'Please fill company field',
            headcount: 'Fill in the number of employees field',
            email: 'Please fill email field',
            emailWrong: 'The email address is in an invalid format',
            phone: 'Please fill phone field',
            phoneShort: 'The phone number must be at least 9 characters long',
            message: 'Tell us briefly what your inquiry is about',
            infoMessage: 'Sending message...',
            errorMessage: 'An error occurred while sending the message. Refresh the page and try again.',
            successTitle: 'Thank you for your message',
            successText: 'We will contact you as soon as possible',
            botMessageTitle: 'An error occurred while sending the message',
            botMessageText: 'An error occurred while submitting the form. Refresh the page and try again. If the problem persists, please contact us: <b>marketing[at]finago.com</b>'
        },
        'sv-SE': {
            name: 'Fyll i förnamn',
            company: 'Fyll i företag',
            headcount: 'Fyll i fältet för antal anställda',
            email: 'Fyll i e-postadress',
            emailWrong: 'E-postadressen har ett ogiltigt format',
            phone: 'Fyll i telefonnummer',
            phoneShort: 'Telefonnumret måste vara minst 9 tecken långt',
            message: 'Berätta kortfattat vad din förfrågan gäller',
            infoMessage: 'Meddelandet skickas...',
            errorMessage: 'Ett fel uppstod vid sändning av meddelandet. Uppdatera sidan och försök igen.',
            successTitle: 'Tack för ditt meddelande',
            successText: 'Vi kontaktar dig så snart som möjligt',
            botMessageTitle: 'Ett fel uppstod vid sändning av meddelandet',
            botMessageText: 'Ett fel uppstod vid sändning av formuläret. Uppdatera sidan och försök igen. Om problemet kvarstår, kontakta oss: <b>marketing[at]finago.com</b>'
        }
    };

    function getLang() {
        const lang = document.documentElement.lang;
        return messagesByLang[lang] ? lang : 'en-US';
    }

    // ===== Viestifunktiot =====
    function infoMessage(form) {
        const lang = getLang();
        const wrapper = form.querySelector('#formMessage');
        if (!wrapper) return;
        wrapper.className = 'message-type__info';
        wrapper.textContent = messagesByLang[lang].infoMessage;
    }

    function errorMessage(form) {
        const lang = getLang();
        const wrapper = form.querySelector('#formMessage');
        if (!wrapper) return;
        wrapper.className = 'message-type__error';
        wrapper.textContent = messagesByLang[lang].errorMessage;
    }

    function successMessage(form) {
        const lang = getLang();
        const messages = messagesByLang[lang];
        form.innerHTML = `
            <div style="text-align: center;">
                <h4>${messages.successTitle}</h4>
                <p>${messages.successText}</p>
            </div>`;
    }

    function botMessage(form) {
        const lang = getLang();
        const messages = messagesByLang[lang];
        form.innerHTML = `
            <div style="text-align: center; color:red;">
                <h4>${messages.botMessageTitle}</h4>
                <p>${messages.botMessageText}</p>
            </div>`;
    }

    function clearMessage(form) {
        const wrapper = form.querySelector('#formMessage');
        if (wrapper) {
            wrapper.className = '';
            wrapper.textContent = '';
        }
    }

    // ===== Lomakevalidointi =====
    function validateInputs(form) {
        let isValid = true;
        const lang = getLang();
        const messages = messagesByLang[lang];

        // Honeypot check
        ['lastname', 'url'].forEach(key => {
            const el = form.querySelector(`#d365mkt-replacement-form-contact-us-${key}`);
            if (el && el.value.trim()) {
                botMessage(form);
                isValid = false;
            }
        });

        const fields = [
            ['name', messages.name],
            ['company', messages.company],
            ['headcount', messages.headcount],
            ['email', messages.email],
            ['tel', messages.phone],
            ['message', messages.message]
        ];

        fields.forEach(([field, msg]) => {
            const input = form.querySelector(`#d365mkt-replacement-form-contact-us-${field}`);
            if (!input) return;

            let error = input.nextElementSibling;
            if (!input.value.trim()) {
                if (!error || !error.classList.contains('error-message')) {
                    error = document.createElement('span');
                    error.className = 'error-message';
                    error.style.color = 'red';
                    error.style.fontSize = '16px';
                    input.after(error);
                }
                error.textContent = msg;
                input.style.borderColor = 'red';
                isValid = false;
            } else {
                if (error?.classList.contains('error-message')) error.remove();
                input.style.borderColor = '';
            }

            // Email format validation
            if (field === 'email' && input.value.trim()) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(input.value.trim())) {
                    let error = input.nextElementSibling;
                    if (!error || !error.classList.contains('error-message')) {
                        error = document.createElement('span');
                        error.className = 'error-message';
                        error.style.color = 'red';
                        error.style.fontSize = '16px';
                        input.after(error);
                    }
                    error.textContent = messages.emailWrong;
                    input.style.borderColor = 'red';
                    isValid = false;
                }
            }

            // Phone length check
            if (field === 'tel' && input.value.trim() && input.value.trim().length < 9) {
                let error = input.nextElementSibling;
                if (!error || !error.classList.contains('error-message')) {
                    error = document.createElement('span');
                    error.className = 'error-message';
                    error.style.color = 'red';
                    error.style.fontSize = '16px';
                    input.after(error);
                }
                error.textContent = messages.phoneShort;
                input.style.borderColor = 'red';
                isValid = false;
            }
        });

        return isValid;
    }

    // ===== Lomakkeiden käsittely =====
    const forms = document.querySelectorAll('.d365mkt-replacement-form');
    forms.forEach(form => {
        const submitButton = form.querySelector('input[type="submit"]');
        if (!submitButton) return;

        submitButton.addEventListener('click', async (event) => {
            event.preventDefault();
            clearMessage(form);

            if (!validateInputs(form)) return;

            infoMessage(form);

            // Disable inputs during processing
            form.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = true);

            const name = form.querySelector('#d365mkt-replacement-form-contact-us-name').value.trim();
            const company = form.querySelector('#d365mkt-replacement-form-contact-us-company').value.trim();
            const headcount = form.querySelector('#d365mkt-replacement-form-contact-us-headcount').value.trim();
            const email = form.querySelector('#d365mkt-replacement-form-contact-us-email').value.trim();
            const phone = form.querySelector('#d365mkt-replacement-form-contact-us-tel').value.trim();
            const message = form.querySelector('#d365mkt-replacement-form-contact-us-message').value.trim();
            const ajaxUrl = form.querySelector('#d365mkt-replacement-form-contact-us-handler').value.trim();

            const data = new URLSearchParams();
            data.append('action', 'd365mkt_replacement_form_handler');
            data.append('name', name);
            data.append('company', company);
            data.append('headcount', headcount);
            data.append('email', email);
            data.append('phone', phone);
            data.append('message', message);
            data.append('url', window.location.href);

            try {
                const response = await fetch(ajaxUrl, {
                    method: 'POST',
                    body: data
                });

                if (response.ok) {
                    const responseData = await response.json();
                    successMessage(form);
                    if (!responseData.success) {
                        form.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = false);
                        errorMessage(form);
                    }
                } else {
                    form.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = false);
                    errorMessage(form);
                }
            } catch (err) {
                form.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = false);
                errorMessage(form);
                console.error('Form submission error:', err);
            }
        });
    });

});


/* function validateInputs() {
    // Translations
    let firstnameMessage;
    let companyMessage;
    let emailMessage;
    let phoneMessage;
    let phoneMessageTooShort;
    let infoMessage;

    const langValue = document.documentElement.lang;

    if (langValue === "fi") {
        firstnameMessage = 'Täytä etunimi kenttä';
        companyMessage = 'Täytä yritys kenttä';
        emailMessage = 'Täytä sähköpostiosoite kenttä';
        emailMessageWrongFormat = 'Sähköpostiosoite on virheellisessä muodossa';
        phoneMessage = 'Täytä puhelin kenttä';
        phoneMessageTooShort = 'Puhelinnumeron tulee olla vähintään 9 merkkiä pitkä';
        infoMessage = 'Kerro meille lyhyesti mitä yhteydenottosi koskee';
    } else {
        firstnameMessage = 'Please fill firstname field';
        companyMessage = 'Please fill company field';
        emailMessage = 'Please fill email field';
        emailMessageWrongFormat = 'The email address is in an invalid format';
        phoneMessage = 'Please fill phone field';
        phoneMessageTooShort = 'The phone number must be at least 9 characters long';
        infoMessage = 'Tell us briefly what your inquiry is about';
    }

    let isValid = true;

    // Check honeypot fields
    const honeypotFields = [
        { id: 'd365mkt-replacement-form-contact-us-lastname' },
        { id: 'd365mkt-replacement-form-contact-us-url' }
    ];

    honeypotFields.forEach(field => {
        const inputElement = document.getElementById(field.id);
        if (inputElement.value !== "") {
            console.log('botti täyttö huomattu');
            botMessage();
            isValid = false;
        }
    });

    // Check fields are not empty
    const requiredFields = [
        { id: 'd365mkt-replacement-form-contact-us-name', message: firstnameMessage },
        { id: 'd365mkt-replacement-form-contact-us-company', message: companyMessage },
        { id: 'd365mkt-replacement-form-contact-us-email', message: emailMessage },
        { id: 'd365mkt-replacement-form-contact-us-tel', message: phoneMessage },
        { id: 'd365mkt-replacement-form-contact-us-message', message: infoMessage },
    ];

    requiredFields.forEach(field => {
        const inputElement = document.getElementById(field.id);
        const errorMessage = document.getElementById(`${field.id}-error`);

        if (!inputElement.value.trim()) {
            if (errorMessage) {
                errorMessage.textContent = field.message;
            } else {
                const errorSpan = document.createElement('span');
                errorSpan.id = `${field.id}-error`;
                errorSpan.className = 'error-message';
                errorSpan.textContent = field.message;
                errorSpan.style.color = 'red';
                errorSpan.style.fontSize = '16px';
                inputElement.parentNode.insertBefore(errorSpan, inputElement.nextSibling);
            }
            inputElement.style.borderColor = 'red';
            isValid = false;
        } else {
            if (errorMessage) {
                errorMessage.remove();
            }
            inputElement.style.borderColor = '';
        }

        // validate email field to be correct email address
        if (field.id === 'd365mkt-replacement-form-contact-us-email' && inputElement.value.trim()) {
            const email = inputElement.value.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const emailFormatValid = emailRegex.test(email);
            if (!emailFormatValid) {
                const emailErrorMessage = document.getElementById(`${field.id}-error`);
                if (emailErrorMessage) {
                    emailErrorMessage.textContent = emailMessageWrongFormat;
                } else {
                    const errorSpan = document.createElement('span');
                    errorSpan.id = `${field.id}-error`;
                    errorSpan.className = 'error-message';
                    errorSpan.textContent = emailMessageWrongFormat;
                    errorSpan.style.color = 'red';
                    errorSpan.style.fontSize = '16px';
                    inputElement.parentNode.insertBefore(errorSpan, inputElement.nextSibling);
                }
                inputElement.style.borderColor = 'red';
                isValid = false;
            }
        }

        // Check that phone is at least 9 mark long
        if (field.id === 'd365mkt-replacement-form-contact-us-tel' && inputElement.value.trim()) {
            const phone = inputElement.value.trim();
            if (phone.length < 9) {
                const phoneErrorMessage = document.getElementById(`${field.id}-error`);
                if (phoneErrorMessage) {
                    phoneErrorMessage.textContent = phoneMessageTooShort;
                } else {
                    const errorSpan = document.createElement('span');
                    errorSpan.id = `${field.id}-error`;
                    errorSpan.className = 'error-message';
                    errorSpan.textContent = phoneMessageTooShort;
                    errorSpan.style.color = 'red';
                    errorSpan.style.fontSize = '16px';
                    inputElement.parentNode.insertBefore(errorSpan, inputElement.nextSibling);
                }
                inputElement.style.borderColor = 'red';
                isValid = false;
            }
        }
    });

    return isValid;
}


function errorMessage() {
    const langValue = document.documentElement.lang;
    let text;

    if (langValue === "fi") {
        text = 'Viestin lähettämisessä tapahtui virhe. Päivitä sivu ja koita lähettää viesti uudelleen.';
    } else {
        text = 'An error occurred while sending the message. Refresh the page and try sending the message again.';
    }

    const messageWrapper = document.getElementById('formMessage');
    messageWrapper.classList.remove('message-type__info');
    messageWrapper.classList.add('message-type__error');
    messageWrapper.textContent = text;
}

function infoMessage() {
    const langValue = document.documentElement.lang;
    let text;

    if (langValue === "fi") {
        text = 'Viestiä lähetetään...';
    } else {
        text = 'Sending message...';
    }

    const messageWrapper = document.getElementById('formMessage');
    messageWrapper.classList.remove('message-type__error');
    messageWrapper.classList.add('message-type__info');
    messageWrapper.textContent = text;
}

function successMessage() {
    const langValue = document.documentElement.lang;
    let titleText;
    let text;

    if (langValue === "fi") {
        titleText = 'Kiitos viestistäsi';
        text = 'Olemme sinuun yhteydessä mahdollisimman pian';
    } else {
        titleText = 'Thank you for your message';
        text = 'We will contact you as soon as possible';
    }

    const d365mktReplacementForm = document.querySelector('.d365mkt-replacement-form');
    d365mktReplacementForm.innerHTML = `
      <div style="text-align: center;">
      <h4>${titleText}</h4>
      <p>${text}</p>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="height: 164px; width: 164px; display: flex; margin: 32px auto;">
        <path fill="#D2E3CB" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
    </svg>
    </div>`
}

function botMessage() {
    const langValue = document.documentElement.lang;
    let titleText;
    let text;

    if (langValue === "fi") {
        titleText = 'Viestin lähettämisessä tapahtui virhe';
        text = 'Lomakkeen lähettämisessä tapahtui virhe. Päivitä sivu ja koita lähettää viesti uudelleen. Mikäli ongelma toistuu, otathan yhteyttä tänne: <b>marketing[at]finago.com</b>';
    } else {
        titleText = 'An error occurred while sending the message';
        text = 'An error occurred while submitting the form. Refresh the page and try sending the message again. If the problem persists, please contact us here: <b>marketing[at]finago.com</b>';
    }

    const d365mktReplacementForm = document.querySelector('.d365mkt-replacement-form');
    d365mktReplacementForm.innerHTML = `
      <div style="text-align: center;">
      <h4>${titleText}</h4>
      <p>${text}</p>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' style='height: 164px; width: 164px; display: flex; margin: 32px auto;' fill='#ff171bff'>
            <path d='M290-459.54h380v-45.38H290v45.38ZM480.07-100q-78.22 0-147.4-29.92t-120.99-81.71q-51.81-51.79-81.75-120.94Q100-401.71 100-479.93q0-78.84 29.92-148.21t81.71-120.68q51.79-51.31 120.94-81.25Q401.71-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.22-29.92 147.4t-81.21 120.99q-51.29 51.81-120.63 81.75Q558.9-100 480.07-100Zm-.07-45.39q139.69 0 237.15-97.76 97.46-97.77 97.46-236.85 0-139.69-97.46-237.15-97.46-97.46-237.15-97.46-139.08 0-236.85 97.46-97.76 97.46-97.76 237.15 0 139.08 97.76 236.85 97.77 97.76 236.85 97.76ZM480-480Z'/>
            </svg>
    </div>`
}

function clearMessage() {
    const messageWrapper = document.getElementById('formMessage');
    messageWrapper.className = '';
    messageWrapper.textContent = '';
}


document.addEventListener('DOMContentLoaded', () => {

    // Get the language setting from the HTML document
    const langValue = document.documentElement.lang;
    // Check what handler we use for this operation
    let handlerSelector;

    const d365mktReplacementForm = document.querySelector('.d365mkt-replacement-form');
    const submitButton = document.getElementById('d365mkt-replacement-form-contact-us-submit');
    if (d365mktReplacementForm) {

        if (langValue === "fi") {
            handlerSelector = 'en';
        } else {
            handlerSelector = 'en';
        }

        submitButton.addEventListener('click', async function (event) {
            
            clearMessage();
            event.preventDefault();

            if (validateInputs()) {
                // The form has been filled out correctly, and the data is being forwarded.
                infoMessage();

                // Disable form inputs while processing
                d365mktReplacementForm.querySelectorAll('.input, input, textarea, select, button').forEach((el) => {
                    el.disabled = true;
                });

                const name = d365mktReplacementForm.querySelector('#d365mkt-replacement-form-contact-us-name').value.trim();
                const company = d365mktReplacementForm.querySelector('#d365mkt-replacement-form-contact-us-company').value.trim();
                const email = d365mktReplacementForm.querySelector('#d365mkt-replacement-form-contact-us-email').value.trim();
                const phone = d365mktReplacementForm.querySelector('#d365mkt-replacement-form-contact-us-tel').value.trim();
                const message = d365mktReplacementForm.querySelector('#d365mkt-replacement-form-contact-us-message').value.trim();
                const ajaxUrl = d365mktReplacementForm.querySelector('#d365mkt-replacement-form-contact-us-handler').value.trim();

                // Prepare form data for submission 
                let data = new URLSearchParams();
                data.append('action', 'd365mkt_replacement_form_handler');
                data.append('name', name);
                data.append('company', company);
                data.append('email', email);
                data.append('phone', phone);
                data.append('message', message);
                data.append('url', window.location.href);

                // Try submitting to the WordPress API
                try {
                    const response = await fetch(ajaxUrl, {
                        method: "POST",
                        body: data,
                    });

                    if (response.ok) {
                        const responseData = await response.json();
                        successMessage();

                        if (responseData.success) {
                            console.log('WP API success');

                        } else {
                            console.error('WP API request failed:', responseData);
                            // Enable form inputs if error occured
                            d365mktReplacementForm.querySelectorAll('.input, input, textarea, select, button').forEach((el) => {
                                el.disabled = false;
                            });
                            errorMessage();
                        }
                    } else {
                        console.error('WP API request failed with status:', response.status);
                        // Enable form inputs if error occured
                        d365mktReplacementForm.querySelectorAll('.input, input, textarea, select, button').forEach((el) => {
                            el.disabled = false;
                        });
                        errorMessage();
                    }
                } catch (error) {
                    console.error('Error in WP API request:', error);
                    // Enable form inputs if error occured
                    d365mktReplacementForm.querySelectorAll('.input, input, textarea, select, button').forEach((el) => {
                        el.disabled = false;
                    });
                    errorMessage();
                }
            }
        });
    }
}); */